import React from "react";

import API from "@beardeddevops/react.api";
import Framework from '@beardeddevops/react.framework';
import Types from "constants/Types";
import TransactionCollection from "components/TransactionCollection";
import TransactionType from "../../constants/TransactionTypes";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Link} from "react-router-dom";
import {Button} from "reactstrap";
import FormPicker from "../Parts/FormPicker";

class Acquisitions extends TransactionCollection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_ACQUISITIONS';
		this.model.set = TransactionType.Acquisition;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(this.props.setTotalCount && (this.state.totalCount !== prevState.totalCount) && typeof this.state.totalCount !== 'undefined' && ((this.state.startDate !== null || this.state.startDate !== "") || (this.state.endDate !== "" || this.start.endDate !== null))) {
			this.props.setTotalCount(this.state.totalCount);
		}
		if(this.props.setTotalCount && (this.state.totalCount !== prevState.totalCount) && typeof this.state.totalCount !== 'undefined' && ((this.state.startDate === null || this.state.startDate === "")  && (this.state.endDate === "" || this.state.endDate === null))) {
			this.props.setTotalCount(0);
		}
	}

	render() {
		const {loading} = this.state;
		return (
			<Card>
				<CardContent>
					{super.render('Acquisitions', 'acquisitions', "Seller", [
						{
							Header: 'Notes',
							accessor: 'notes',
							show: !!this.state.column_notes,
							toggle: 'column_notes'
						},
						{
							Header: "",
							className: "button-cell",
							filterable: false,
							sortable: false,
							width: 80,
							show: !!this.props.rootState.hasMichiganRIModule || this.props.rootState.hasRIComboModule,
							Cell: props => (
								<FormPicker 
									row={props.original} 
									locations={this.props.locations}
									history={this.props.history}
									rootState={this.props.rootState}
								/>
							)
						},

					])}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(Acquisitions);
